export default __webpack_public_path__ + "static/media/ritual.f1ce6351.JPG";